:host {
  --aha-modal-body-danger--width: 300px;
  --aha-modal-body--padding-bottom: var(--spacer-8);

  display: block;
}
/* NOTE: Because Safari does not support constructed stylesheets, we need to scope `aha-modal-body` with `:host`, otherwise the `display` rule here will be overriden by the default value in the <aha-modal-body> stylesheet. */
:host #header {
  display: flex;
  gap: var(--spacer-2);
  align-items: baseline;
}

:host #header-text {
  font-size: var(--font-size-h-500);
  font-weight: 600;
  display: flex;
  flex-direction: column;
}
:host slot[name='subheader'] {
  font-size: var(--font-size-h-700);
  font-weight: 400;
}
:host #content {
  font-size: 0.875rem;
  margin-top: var(--spacer-2);
}
:host #content ::slotted(p:last-child) {
  margin-bottom: 0 !important;
}
